import { FormlyFieldConfig } from '@ngx-formly/core';

export function decimalValidatorMessage(error: unknown, field: FormlyFieldConfig): string {
  return `Please enter a valid number. Ex: 123.12`;
}
